<template lang="pug">
v-app()
  payment-order-header
  .payment-order-layout
    .payment-order-layout__container
      payment-order-footnote
      .payment-order-layout__form
        payment-order-form.payment-order-layout__form-half( ref="paymentOrderForm" )
          .payment-order-layout__qrcode-in-form
            payment-order-QRcode
            v-divider.payment-order-layout_divider--color( horizontal )
        v-divider.payment-order-layout_divider--invisible.payment-order-layout_divider--color( vertical )
        payment-order-QRcode.payment-order-layout__qrcode-out-form
</template>

<script>
import PaymentOrderHeader from '@/pages/paymentOrder/PaymentOrderHeader.vue'
import PaymentOrderForm from '@/pages/paymentOrder/PaymentOrderForm.vue'
import PaymentOrderQRcode from '@/pages/paymentOrder/PaymentOrderQRcode.vue'
import PaymentOrderFootnote from '@/pages/paymentOrder/PaymentOrderFootnote.vue'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  components: {
    PaymentOrderHeader,
    PaymentOrderForm,
    PaymentOrderQRcode,
    PaymentOrderFootnote
  },

  props: {
    sudAlias: { type: String, default: "" },
    regionAlias: { type: String, default: "" }
  },

  computed: {
    ...mapState('expert', ['region'])
  },

  methods: {
    ...mapMutations('expert', ['setQRCodeImg']),
    ...mapActions('expert', ['fetchRegionByAlias'])
  },

  mounted() {
    this.setQRCodeImg(null)
    this.fetchRegionByAlias(this.regionAlias).then(hasError => {
      if (hasError) this.$router.push({ path: '/payment_order' })
      else this.$refs.paymentOrderForm.setCourt(this.region.courtCards.find(court => court.alias == this.sudAlias))
    })
  }
}
</script>

<style scoped>
.payment-order-layout {
  background-color: white; 
  color: black; 
  height: 100%;
  padding: 50px 80px;
  display: flex;
}
.payment-order-layout__container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.payment-order-layout__form {
  display: flex;
  padding: 50px 0px;
  justify-content: space-between;
}
.payment-order-layout__form-half {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.payment-order-layout_divider--color {
  background-color: #EEEEEE;
}
.payment-order-layout__qrcode-in-form {
  display: none;
}
.payment-order-layout__qrcode-out-form {
  display: flex;
}

@media screen and (max-width: 1280px) {
  .payment-order-layout {
    padding: 50px;
  }
  .payment-order-layout__container {
    width: 960px;
  }
}

@media screen and (max-width: 980px) {
  .payment-order-layout_divider--invisible {
    display: none;
  }
  .payment-order-layout {
    padding: 35px;
  }
  .payment-order-layout__container {
    width: 100%;
  }
  .payment-order-layout__form {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
  .payment-order-layout__qrcode-in-form {
    display: flex;
    gap: 30px;
    flex-direction: column;
  }
  .payment-order-layout__qrcode-out-form {
    display: none;
  }
}
</style>